import { useMemo } from 'react';

import { clientConfig } from '@/config/clientConfig';

import { useFileLoader } from './useFileLoader';
import { useGqlLoader } from './useGqlLoader';

export const useLoader = () => {
  const graphQLLoader = useGqlLoader();
  const fileLoader = useFileLoader();

  return useMemo(
    () => ({
      loader: clientConfig.isExported ? fileLoader : graphQLLoader,
    }),
    [clientConfig.isExported, fileLoader, graphQLLoader],
  );
};
